module.exports = __webpack_public_path__ + "static/media/PRISM_6623.03269163.jpg";